import { Injectable } from '@angular/core';
import { ApproveRequestDetails } from '../model/ApproveRequestDetails';
import { ApproveResponseDetails } from '../model/ApproveResponseDetails';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, catchError, retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { throwError, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApproveServiceService {

  response: ApproveResponseDetails[];
  httpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  httpOptions = {
    headers: this.httpHeaders

  };

  readonly rootURL = environment.ApiUrl;
  constructor(private http: HttpClient) { }

  fetchUploadedData(data): Observable<ApproveResponseDetails[]> {

    jsondata: String;
    jsondata: JSON.stringify(data);
    return this.http.post<ApproveResponseDetails[]>(this.rootURL + 'Visiting/GetApproveDetails', JSON.stringify(data), this.httpOptions)
      .pipe(
        retry(0),
        catchError(this.errorHandl)
      )
  }
  SaveAprroveDetails(request: Observable<ApproveResponseDetails[]>) {

    jsondata: String;
    jsondata: JSON.stringify(request);
    return this.http.post<ApproveResponseDetails[]>(this.rootURL + 'Visiting/UpdateApproveStatus', JSON.stringify(request), this.httpOptions)
      .pipe(
        retry(0),
        catchError(this.errorHandl)
      )
  }
  // Error handling
  errorHandl(error) {

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }

}
